import React, { useContext } from 'react';
import StateContext from 'common/contexts/state-context';
import { LISTING_COPY } from '../../../staticContent';

/**
 * Bloc de liens villes (décision 6) — absent de la maquette, ajouté pour le
 * maillage interne. Alimenté par `state.sl.search_shortcuts`.
 *
 * §10 du plan : l'environnement de test en a 0 aujourd'hui — le bloc rend
 * `null` tant que le client n'en configure pas. C'est une action client, pas
 * du code (§17.2).
 */
const CityLinks = () => {
  const [state] = useContext(StateContext);
  const shortcuts = (state.sl && state.sl.search_shortcuts) || [];
  if (!shortcuts.length) return null;

  return (
    <section className="city-links" aria-label="Salons par ville">
      <div className="container">
        <h2>{LISTING_COPY.cityLinksTitle}</h2>
        <nav className="city-links-list">
          {shortcuts
            .filter((shortcut) => shortcut.indexing)
            .map((shortcut) => (
              <a key={shortcut.slug} href={shortcut.slugUrl}>
                {shortcut.label}
              </a>
            ))}
        </nav>
      </div>
    </section>
  );
};

export default CityLinks;
